import { useFormik } from "formik";
import { useEffect } from "react";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import OTPInput from "react-otp-input";
import MainService from "../../common/MainService";
import { useNavigate } from "react-router-dom";

const OTPView = ({ data }) => {
  const [OTPBtnDisabled, setOTPBtnDisabled] = useState(true);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.otp || values.otp.length < 6) {
        errors.otp = "Please enter a valid 6-digit OTP";
      }
      return errors;
    },
    onSubmit: async (values) => {
      const data1 = JSON.stringify({
        mobile: data.phone,
        otp: values.otp,
        email: data.email,
      });

      try {
        const url = `${window.livasaConfig.validateOtp}${window.livasaConfig.networkid}/${window.livasaConfig.clientId}/${window.livasaConfig.clientSecret}`;
        const res = await fetch(url, {
          method: "POST",
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
          body: data1,
        });

        const result = await res.text();
        if (result === "OTP validated") {
          const _data = {
            source: data.email,
            destination: `${window.livasaConfig.networkid}`,
            username: data.email,
            usertype: "",
            phone: data.phone,
            email: data.email,
            requesttype: "demo",
            json: {
              company: data.company,
              name: data.name,
              phone: data.phone,
              email: data.email,
              enterpriseSize: data.role,
            },
          };
          MainService.sendRequest(_data)
            .then(() => {
              enqueueSnackbar("Request Sent. We will get back to you soon", {
                variant: "success",
                autoHideDuration: 4000,
              });
              setTimeout(() => {
                navigate("/");
              }, 1000);
            })
            .catch((err) => {
              enqueueSnackbar(`Error: ${err}`, {
                variant: "error",
                autoHideDuration: 4000,
              });
            });
        } else if (result !== "OTP validated") {
          enqueueSnackbar(result, { variant: "error", autoHideDuration: 4000 });
        }
      } catch (err) {
        enqueueSnackbar("Something went wrong", {
          variant: "error",
          autoHideDuration: 4000,
        });
      }
    },
  });

  const renderInput = (inputProps, index) => (
    <input
      {...inputProps}
      key={index}
      maxLength={1}
      type="text"
      className="custom-otp-input"
    />
  );
  useEffect(() => {
    const timer = setTimeout(() => {
      setOTPBtnDisabled(false);
    }, 60000);

    return () => clearTimeout(timer); // cleanup
  }, []);

  const resendOTP = () => {
    setOTPBtnDisabled(true);
    const body_data = {
      email: data.email,
    };
    // Re-enable button after 91 minutes
    setTimeout(() => {
      setOTPBtnDisabled(false);
    }, 60000);

    fetch(
      `${window.livasaConfig.resendOTP}${data.phone}/${window.livasaConfig.networkid}/${window.livasaConfig.clientId}/${window.livasaConfig.clientSecret}`,
      {
        method: "POST",
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body_data),
      }
    )
      .then(async (res) => {
        const text = await res.text(); // get response body as text

        if (res.ok) {
          enqueueSnackbar(text, { variant: "success", autoHideDuration: 4000 });
        } else {
          enqueueSnackbar(`Error: ${text}`, {
            variant: "error",
            autoHideDuration: 4000,
          });
          // Optional: re-disable or leave button disabled
        }
      })
      .catch((err) => {
        console.log("err", err);
        enqueueSnackbar("Something went wrong", {
          variant: "error",
          autoHideDuration: 4000,
        });
      });
  };

  return (
    <Container>
      <Row>
        <Col md={7}>
          <form onSubmit={formik.handleSubmit}>
            <OTPInput
              value={formik.values.otp}
              onChange={(otp) => formik.setFieldValue("otp", otp)}
              numInputs={6}
              isInputNum
              renderInput={renderInput}
              renderSeparator={<span>-</span>}
              inputStyle={{
                border: "1px solid #666666",
                borderRadius: "8px",
                width: "40px",
                height: "40px",
                fontSize: "14px",
                color: "#000",
                fontWeight: "500",
                caretColor: "#666666",
              }}
              focusStyle={{
                outline: "none",
              }}
            />

            {formik.errors.otp && (
              <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                {formik.errors.otp}
              </div>
            )}

            <button
              type="submit"
              className="pt-2 pb-2 px-3 rounded mt-3 btn btn-primary"
            >
              Verify OTP
            </button>
          </form>

          <p className="mb-4 mt-3 resend-otp">
            Didn’t receive OTP?{" "}
            <span
              onClick={resendOTP}
              style={{
                color: OTPBtnDisabled ? "gray" : "#007bff",
                cursor: OTPBtnDisabled ? "not-allowed" : "pointer",
                textDecoration: "underline",
                pointerEvents: OTPBtnDisabled ? "none" : "auto",
              }}
            >
              Resend OTP
            </span>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default OTPView;
